import { ParagraphNode, SerializedParagraphNode, EditorConfig, NodeKey } from 'lexical';

export type SerializedCustomParagraphNode = SerializedParagraphNode & {
  __blockId?: string;
  Modified?: 'true' | 'false' | 'added' | 'removed';
};

export class CustomParagraphNode extends ParagraphNode {
  __blockId?: SerializedCustomParagraphNode['__blockId'];
  Modified?: SerializedCustomParagraphNode['Modified'];

  static getType(): string {
    return 'paragraph';
  }

  static clone(node: CustomParagraphNode): CustomParagraphNode {
    return new CustomParagraphNode(node.__blockId, node.Modified, node.__key);
  }

  constructor(__blockId?: SerializedCustomParagraphNode['__blockId'], Modified?: SerializedCustomParagraphNode['Modified'], key?: NodeKey) {
    super(key);

    this.__blockId = __blockId;
    this.Modified = Modified;
  }

  exportJSON(): SerializedCustomParagraphNode {
    const json = super.exportJSON() as SerializedCustomParagraphNode;
    if (this.__blockId) {
      json.__blockId = this.__blockId;
    }
    if (this.Modified !== undefined) {
      json.Modified = this.Modified;
    }
    return json;
  }

  static importJSON(serializedNode: SerializedCustomParagraphNode): CustomParagraphNode {
    const node = new CustomParagraphNode(serializedNode.__blockId, serializedNode.Modified);

    // Preserve formatting
    node.setFormat(serializedNode.format || '');
    node.setDirection(serializedNode.direction || null);
    node.setIndent(serializedNode.indent || 0);
    return node;
  }

  createDOM(config: EditorConfig): HTMLElement {
    const dom = super.createDOM(config);

    if (this.__blockId) {
      dom.setAttribute('data-block-id', this.__blockId);
    }

    if (this.Modified === 'true') {
      dom.classList.add('modified-block', 'true');
    } else if (this.Modified === 'added') {
      dom.classList.add('modified-block', 'added');
    } else if (this.Modified === 'removed') {
      dom.classList.add('modified-block', 'removed');
    }

    return dom;
  }

  static importDOM(): Record<string, any> | null {
    return {
      p: () => ({
        conversion: () => ({ node: new CustomParagraphNode() }),
        priority: 1,
      }),
    };
  }
}